<import from="../../value-converters/abn-format"></import>

<div>
  <tooltip hidden="true">
    <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit</p>
    <p>
      Aenean commodo ligula eget dolor. Aenean massa pellentesque eu pretium
      quis, sem.
    </p>
  </tooltip>

  <label for="abnLookupField">ABN lookup</label>
  <div class="input-container">
    <input
      autocomplete="off"
      class="abn"
      id="abnLookupField"
      type="text"
      value.bind="userFieldValue & validate:'manual'"
      placeholder.bind="placeholder"
      keypress.trigger="handleKeyPress($event)"
    />
    <button
      type="button"
      click.trigger="doSearch()"
      disabled.bind="buttonDisabled"
      class="flex-centre-button ${showSearch ? 'active' : ''}"
    >
      search
    </button>
  </div>
</div>

<template if.bind="selectedResult && manuallySelected">
  <input
    type="hidden"
    class="common-question"
    id="entityTypeCode"
    name="AbnEntityTypeCode"
    value.bind="selectedResult.entityTypeCode"
    data-autorate-name="common_question_entity_type_code"
  />
  <input
    type="hidden"
    class="common-question"
    id="entityTypeDesc"
    name="AbnEntityTypeDesc"
    value.bind="selectedResult.entityTypeDescription"
    data-autorate-name="common_question_entity_type_desc"
  />
  <input
    type="hidden"
    class="common-question"
    id="gstRegistered"
    name="GstRegistered"
    value.bind="selectedResult.gstRegistered"
    data-autorate-name="common_question_gst_registered"
  />
  <input
    type="hidden"
    class="common-question"
    id="gstExempt"
    name="GstExempt"
    value.bind="selectedResult.gstExempt"
    data-autorate-name="common_question_gst_exempt"
  />

  <div>
    <tooltip hidden="true">
      <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit</p>
      <p>
        Aenean commodo ligula eget dolor. Aenean massa pellentesque eu pretium
        quis, sem.
      </p>
    </tooltip>

    <label for="AbnNumber">abn</label>
    <div>
      <input
        class="common-question"
        id="AbnNumber"
        name="AbnNumber"
        type="text"
        readonly="readonly"
        value.bind="selectedResult.number | abnFormat"
        data-autorate-name="common_question_abn_number"
      />
    </div>
  </div>

  <div>
    <tooltip hidden="true">
      <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit</p>
      <p>
        Aenean commodo ligula eget dolor. Aenean massa pellentesque eu pretium
        quis, sem.
      </p>
    </tooltip>

    <label for="AbnName">name</label>
    <div>
      <input
        class="common-question"
        id="AbnName"
        name="InsuredName"
        type="text"
        readonly="readonly"
        value.bind="selectedResult.name"
        data-autorate-name="common_question_insured_name"
      />
    </div>
  </div>
</template>

<template if.bind="results.length > 0">
  <div class="abn-search-results">
    <div repeat.for="result of results">
      <label for="result"> ${result.abn | abnFormat} - ${result.name}</label>
      <button type="button" class="flex-centre-button" click.trigger="selectAbn(result)">Select</button>
    </div>
  </div>
</template>
